import { jsx as _jsx } from "react/jsx-runtime";
import { oaQuery } from "@/shared/hooks";
import { useEffect, useState } from "react";
import './index.less';
const search = window.location.search;
export const FreeAnchorLayout = ({ children, style, className, id, type }) => {
    const [isOa, setIsOa] = useState(false);
    useEffect(() => {
        if ((search && search.includes(oaQuery)) || type === 'detail') {
            setIsOa(true);
        }
    }, [search]);
    return _jsx("div", { id: id, className: `${isOa ? 'free-anchor-layout__oa' : 'free-anchor-layout'} ${className}`, style: style || {}, children: children });
};
